/**
 * Route shell for single preference-type edit overlay.
 *
 * Belongs here: scope=Single wrapper.
 * Does not belong here: question UI (see PreferencesQuestionnairePage).
 */
import { useParams } from 'react-router-dom'
import { usePreferencesContext } from '../flow-engine/PreferencesProvider'
import { PreferencesQuestionnairePageContent } from './PreferencesQuestionnairePage'
import { PreferencesQuestionnaireScope } from '../setup/types'

export default function AllocationPreferencesPreferenceTypeQuestionnairePage() {
  const { preferenceTypeId } = useParams<{ preferenceTypeId: string }>()
  const { preferenceTypes, isPreferenceTypesLoading, returnToReview } = usePreferencesContext()

  if (!preferenceTypes.length) {
    if (isPreferenceTypesLoading) {
      return (
        <div className='flex min-h-screen items-center justify-center bg-white px-5'>
          <p className='text-gray-600'>Loading…</p>
        </div>
      )
    }
    returnToReview()
    return null
  }

  const typeExists = preferenceTypes.some((preferenceType) => preferenceType.id === preferenceTypeId)
  if (!preferenceTypeId || !typeExists) {
    returnToReview()
    return null
  }

  return (
    <PreferencesQuestionnairePageContent
      scope={PreferencesQuestionnaireScope.Single}
      preferenceTypeId={preferenceTypeId}
    />
  )
}
